"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocaleTranslations = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var next_intl_1 = require("next-intl");
var react_html_parser_1 = __importDefault(require("react-html-parser"));
var replaceVariables_1 = require("./replaceVariables");
var parseAndReplaceBonusString = function (sourceString, currency) {
    var regex = /{{(\w+):\s*({[^{}]*})}}/;
    var match = sourceString.match(regex);
    if (!match) {
        return sourceString;
    }
    var valueString = match[2];
    var valueObject;
    try {
        valueObject = JSON.parse(valueString.replace(/(\w+):/g, '"$1":'));
    }
    catch (e) {
        return sourceString;
    }
    if (!valueObject[currency]) {
        return sourceString;
    }
    var amount = valueObject[currency];
    return sourceString.replace(regex, "".concat(amount, " ").concat(currency));
};
var useLocaleTranslations = function () {
    var _a, _b, _c;
    var lang = (0, next_intl_1.useLocale)();
    var prevLang = (0, react_1.useRef)(lang);
    var _d = (0, useQuery_1.useQuery)({
        path: keys_1.TRANSLATIONS,
        revalidateOnMount: true,
        payload: {
            input: {
                code: lang.toLowerCase(),
            },
        },
    }), data = _d.data, isLoading = _d.isLoading, mutate = _d.mutate;
    (0, react_1.useEffect)(function () {
        if (prevLang.current !== lang) {
            mutate();
            prevLang.current = lang;
        }
    }, [lang, mutate]);
    return (0, react_1.useCallback)(function (str, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (options === void 0) { options = {}; }
        if ((options === null || options === void 0 ? void 0 : options.direct) && str)
            return (_d = (((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.edge) === null || _c === void 0 ? void 0 : _c.translations) || {})) === null || _d === void 0 ? void 0 : _d[str];
        if (!str)
            return str;
        if (isLoading)
            return '';
        var result = ((_h = (((_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.get) === null || _f === void 0 ? void 0 : _f.edge) === null || _g === void 0 ? void 0 : _g.translations) || {})) === null || _h === void 0 ? void 0 : _h[str]) || str;
        // return parse(parseAndReplaceBonusString(result, currentCurrency));
        if (options === null || options === void 0 ? void 0 : options.ignoreReplaceNextLine)
            return (0, react_html_parser_1.default)((0, replaceVariables_1.replaceVariables)(result, (options.variables = {})));
        return (0, react_html_parser_1.default)((0, replaceVariables_1.replaceVariables)(result, (options.variables = {})).replace(/\n/g, '<br/>'));
    }, [(_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.get) === null || _b === void 0 ? void 0 : _b.edge) === null || _c === void 0 ? void 0 : _c.translations, isLoading]);
};
exports.useLocaleTranslations = useLocaleTranslations;
